module.exports = __webpack_public_path__ + "media/images/mypage/mypage_box_bottom-4f9c02057653eac98dcb5e8a59fa7c33.png";